<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <cliente-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import ClienteShowData from "./ClienteShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "ClienteShow",
        components: {CrudShow, ClienteShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cliente.showing',
            }
        },
    }
</script>
